// Campus photo for /colleges/university-of-central-florida: CC BY-SA 2.0, by elisfkc from Orlando, FL, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AReflecting_Pond_(30098171300).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-central-florida/; credited under the photo.
const photo = {
    "slug": "university-of-central-florida",
    "alt": "The Reflecting Pond fountains in front of the John C. Hitt Library at the University of Central Florida in Orlando",
    "src": "/colleges/university-of-central-florida/campus-1600.webp",
    "srcSmall": "/colleges/university-of-central-florida/campus-800.webp",
    "srcMid": "/colleges/university-of-central-florida/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-central-florida/og.jpg",
    "title": "Reflecting Pond (30098171300)",
    "author": "elisfkc from Orlando, FL, United States",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AReflecting_Pond_(30098171300).jpg",
    "read": "2026-10-01"
};

export default photo;
